<template>
  <div v-if="reviews.length" class="gs-section">
    <div class="gs-section__toolbar">
      <p class="gs-section__count">{{ countLabel }}</p>
    </div>

    <div class="gs-asset-grid">
      <asset-card v-for="review in reviews" :key="review.id" :title="review.name">
        <template slot="preview">
          <div v-if="embedFor(review)" class="gs-asset-video">
            <iframe
              :src="embedFor(review)"
              :title="review.name"
              allowfullscreen
            ></iframe>
          </div>
          <div v-else class="gs-asset-mono">{{ review.video }}</div>
        </template>

        <template slot="default">
          <p class="gs-asset-label">{{ $t('frontend_resources_description') }}</p>
          <div class="gs-asset-well">
            <pre class="gs-asset-text gs-video-description">{{ review.description }}</pre>
          </div>
        </template>

        <template slot="actions">
          <copy-button
            :text="review.video"
            label="Copy URL"
            title="Copy the video URL"
          />
          <copy-button
            v-if="review.description"
            :text="review.description"
            label="Copy description"
            title="Copy the video description"
          />
          <span class="gs-share">
            <vue-goodshare-facebook
              :page_url="review.affiliate_link"
              :page_description="review.description"
              :quote="review.description"
              title_social="Share On Facebook"
              has_icon
            ></vue-goodshare-facebook>
          </span>
        </template>
      </asset-card>
    </div>
  </div>

  <div v-else class="gs-empty">
    <span class="gs-empty__icon"><gs-icon name="play" size="22" /></span>
    <p class="gs-empty__title">{{ $t('frontend_resources_no_video') }}</p>
    <p class="gs-empty__text">Review videos you can embed or share show up here.</p>
  </div>
</template>

<script>
import urlParser from 'js-video-url-parser/lib/base';
import VueGoodshareFacebook from 'vue-goodshare/src/providers/Facebook.vue';
import AssetCard from '@/components/promotools/AssetCard.vue';
import CopyButton from '@/components/promotools/CopyButton.vue';

export default {
  components: {
    VueGoodshareFacebook,
    AssetCard,
    CopyButton,
  },
  props: {
    funnelResource: {
      type: Object,
      required: true,
    },
  },
  computed: {
    reviews() {
      return (this.funnelResource && this.funnelResource.video_reviews
        ? this.funnelResource.video_reviews.filter(review => review.enabled)
        : []);
    },
    countLabel() {
      const count = this.reviews.length;
      return `${count} ${count === 1 ? 'video' : 'videos'}`;
    },
  },
  methods: {
    // A URL the parser does not recognise falls back to showing the raw link
    // rather than an iframe pointed at nothing.
    embedFor(review) {
      const videoInfo = review.video ? urlParser.parse(review.video) : null;

      if (!videoInfo) {
        return '';
      }

      if (videoInfo.provider === 'youtube') {
        return `https://www.youtube.com/embed/${videoInfo.id}`;
      }

      if (videoInfo.provider === 'vimeo') {
        return `https://player.vimeo.com/video/${videoInfo.id}`;
      }

      return '';
    },
  },
};
</script>

<style scoped>
.gs-video-description {
  max-height: 132px;
  overflow-y: auto;
}

.gs-share {
  display: inline-flex;
}

.gs-share ::v-deep .button-social {
  margin: 0;
}
</style>
